import { z } from 'zod';

export const entityTypeSchema = z.enum([
    'family',
    'cluster',
    'role',
    'level',
    'competency',
    'skill',
    'job_architecture',
    'user',
]);

export type EntityType = z.infer<typeof entityTypeSchema>;

export const entityIdentifierSchema = z.object({
    clusterId: z.uuid().nullable().optional(),
    familyId: z.uuid().nullable().optional(),
    id: z.uuid().nullable().optional(),
    jobArchitectureId: z.uuid().nullable().optional(),
    levelId: z.uuid().nullable().optional(),
    roleId: z.uuid().nullable().optional(),
    type: entityTypeSchema,
    version: z.number().nullable().optional(),
});

export type EntityIdentifier = z.infer<typeof entityIdentifierSchema>;
